import { render, staticRenderFns } from "./ClassListEdit.vue?vue&type=template&id=2c48aafa&"
import script from "./ClassListEdit.vue?vue&type=script&lang=js&"
export * from "./ClassListEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClassListEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports